import styles from "./MegaQuiz.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
export default function ResultScreen({
  score,
  total,
}) {
  const navigate=useNavigate();
  return (
    <div className={styles.resultContainer}>
      <div className={styles.resultCard}>
        <h1>Quiz Completed 🎉</h1>

        <h2>
          {score} / {total}
        </h2>

        <p>
          Correct Answers: {score / 5}
        </p>
         <button 
          onClick={() => navigate("/")} // Navigates user back to home route
          style={{
            padding: "14px 32px",
            fontSize: "16px",
            fontWeight: "600",
            backgroundColor: "#d8491d",
            color: "#ffffff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(29, 78, 216, 0.3)",
            transition: "transform 0.2s, background-color 0.2s",
          }}
          // onMouseEnter={(e) => e.target.style.backgroundColor = "#1e40af"}
          // onMouseLeave={(e) => e.target.style.backgroundColor = "#1d4ed8"}
        >
          Go Back Home
        </button>
      </div>
       
    </div>
  );
}